import LongText from '@arivaa-react/components/longtext';
import { Crud } from '../../containers/crud/crud';
import { translate } from '../../../localization';
import { WebCrud } from '../../containers/crud/webCrud';
export default function Enhancement() {
  return (
    <WebCrud api="contact" query={['category;Enhancement']}>
      <Crud.Header title="Enhancement Requests">
        <Crud.Header.Actions>
          <Crud.Header.Actions.Refresh />
          <Crud.Header.Actions.Secondary>
            <Crud.Header.Actions.CsvImport />
            <Crud.Header.Actions.SampleCsvExport />
          </Crud.Header.Actions.Secondary>
        </Crud.Header.Actions>
      </Crud.Header>
      <Crud.Table
        columns={[
          {
            title: translate('support.email.label'),
            dataIndex: 'email',
          },
          {
            title: translate('support.name.label'),
            dataIndex: 'name',
          },
          {
            title: translate('support.message.label'),
            dataIndex: 'message',
            render: (message) => {
              return <LongText text={message} limit={25} title="Message" />;
            },
          },
          {
            title: translate('support.page.label'),
            dataIndex: 'page',
          },
          {
            title: 'Product',
            dataIndex: 'otherInfo',
            render: (val) => {
              return val?.product ? val.product : '';
            },
          },
          {
            title: 'Phone',
            dataIndex: 'otherInfo',
            render: (val) => {
              return val?.phone ? val.phone : '';
            },
          },
        ]}
      >
        <Crud.Table.TableActions.Common />
        <Crud.Table.Header>
          <Crud.Search
            fields={[
              {
                type: 'text',
                name: 'name',
                inputProps: {
                  placeholder: 'Name',
                },
              },
              {
                type: 'text',
                name: 'email',
                inputProps: {
                  placeholder: 'Email',
                },
              },
              {
                type: 'text',
                name: 'message',
                inputProps: {
                  placeholder: 'Message',
                },
              },
              {
                type: 'phone',
                key: 'otherInfo',
                inputProps: {
                  placeholder: 'Phone Number',
                },
              },
            ]}
          ></Crud.Search>
          <Crud.Table.BulkRowActions.Common />
        </Crud.Table.Header>
      </Crud.Table>
    </WebCrud>
  );
}
